import React from 'react';
import { AlertCircle } from 'lucide-react';
import { motion } from 'framer-motion';
const problemas = [{
  title: 'Pacientes que abandonan tratamientos',
  description: 'Sin seguimiento perdés pacientes que podrías retener fácilmente.'
}, {
  title: 'Horas perdidas armando planes desde cero',
  description: 'Cada consulta te lleva el doble de tiempo sin plantillas listas.'
}, {
  title: 'Casos complejos que no sabés cómo resolver',
  description: 'Te quedás trabada con pacientes que requieren intervenciones específicas.'
}, {
  title: 'Baja adherencia y resultados estancados',
  description: 'Tus pacientes no logran sus objetivos y no sabés cómo cambiar la estrategia.'
}, {
  title: 'Consultorio desorganizado y caótico',
  description: 'Formularios sueltos, registros sin orden y seguimiento improvisado.'
}, {
  title: 'Inseguridad al cobrar lo que valés',
  description: 'Sin un sistema profesional te cuesta posicionarte y diferenciarte.'
}];
export function Problematicas() {
  return <section className="w-full py-10 md:py-14 bg-gradient-to-b from-emerald-50 to-white" data-id="element-184">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-185">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-6" data-id="element-186">
          <div className="inline-flex items-center gap-2 bg-red-100 text-red-700 px-4 py-1.5 rounded-full text-xs font-bold mb-3" data-id="element-187">
            ⚠️ ¿TE PASA ESTO?
          </div>
          <h2 className="text-2xl md:text-4xl font-bold text-slate-900" data-id="element-188">
            Problemas que{' '}
            <span className="text-red-600" data-id="element-189">frenan tu consultorio</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-190">
          {problemas.map((problema, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05,
          duration: 0.3
        }} className="bg-red-50 border border-red-200 rounded-xl p-4 hover:shadow-md transition-shadow duration-300" data-id="element-191">
              <div className="flex items-start gap-2.5" data-id="element-192">
                <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-193" />
                <div data-id="element-194">
                  <h3 className="font-bold text-slate-900 text-sm md:text-base leading-tight mb-1" data-id="element-195">
                    {problema.title}
                  </h3>
                  <p className="text-slate-600 text-xs md:text-sm leading-snug" data-id="element-196">
                    {problema.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}